export function htmlToPlainText(html: string): string {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  function getTextWithLineBreaks(node: Node): string {
    let text = '';

    node.childNodes.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        text += child.textContent;
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const tag = (child as HTMLElement).tagName.toLowerCase();

        if (tag === 'br') {
          text += '\n';
        } else {
          // Recurse
          text += getTextWithLineBreaks(child);

          // Add line breaks after block elements
          if (['p', 'div', 'li', 'section', 'article', 'header', 'footer', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tag)) {
            text += '\n';
          }
        }
      }
    });

    return text;
  }

  return getTextWithLineBreaks(tempDiv).replace(/\n{3,}/g, '\n\n').trim();
}